var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerduennbar = function SvgVerduennbar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "verduennbar_svg__Ebene_2",
    viewBox: "0 0 93.46 97.8"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".verduennbar_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2.3px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verduennbar_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.75 1.15v95.49c26.28-.1 47.56-21.44 47.56-47.74S71.03 1.26 44.75 1.15Z",
    className: "verduennbar_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.69,
    cy: 23.11,
    r: 11.89,
    className: "verduennbar_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.95,
    cy: 53.27,
    r: 8.15,
    className: "verduennbar_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.09,
    cy: 32.57,
    r: 5.94,
    className: "verduennbar_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.69,
    cy: 77.71,
    r: 7.05,
    className: "verduennbar_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.3,
    cy: 68.68,
    r: 4.62,
    className: "verduennbar_svg__cls-1"
  }))));
};
export default SvgVerduennbar;